var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVscode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_9118335_vscode_fill_icon",
    "data-name": "9118335_vscode_fill_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 102.724,
    height: 102.724,
    viewBox: "0 0 102.724 102.724",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M.977,17.269s-2.5-1.823.5-4.257l7-6.323s2-2.129,4.118-.274l64.551,49.4V79.5s-.031,3.72-4.754,3.309Z",
    transform: "translate(0 18.553)",
    fill: "#068bff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M17.449,11.937.811,27.226s-1.71,1.286,0,3.583l7.725,7.1s1.835,1.992,4.545-.274L30.72,24.118Z",
    transform: "translate(0.166 39.155)",
    fill: "#068bff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M23.156,50.554,53.67,27l-.2-23.562S52.168-1.7,47.821.974L7.216,38.33Z",
    transform: "translate(23.669 0.663)",
    fill: "#068bff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M17.6,101.4a4.165,4.165,0,0,0,3.92,1.233L45.3,90.786c3.044-2.1,2.617-4.7,2.617-4.7V15.357c0-3.109-3.148-4.183-3.148-4.183L24.156,1.132c-4.5-2.814-7.454.506-7.454.506S20.5-1.123,22.353,4.1V97.625a4.289,4.289,0,0,1-.407,1.844c-.542,1.106-1.72,2.139-4.546,1.707Z",
    transform: "translate(54.788 0)",
    fill: "#068bff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVscode);
export default __webpack_public_path__ + "static/media/vscode.ba13e134ae9027436207189868cc750b.svg";
export { ForwardRef as ReactComponent };